import React from 'react';
import { ReactQueryClientProvider } from 'src/providers/ReactQueryClientProvider';
import { ThemeProvider } from 'src/providers/ThemeProvider';
import { UserGuidingPingProvider } from 'src/lib/services/user-guiding';

type Props = React.PropsWithChildren;

const Providers: React.FC<Props> = (props) => {
  return (
    <React.Fragment>
      <ReactQueryClientProvider>
        <UserGuidingPingProvider />
        <ThemeProvider>{props.children}</ThemeProvider>
      </ReactQueryClientProvider>
    </React.Fragment>
  );
};

export default Providers;
